import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { KentRebalancingPlan } from '@cast/types';

import { getKentRebalancePlanQueryKey } from 'hooks/queries/rebalancer/useKentRebalancePlansQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useExecuteKentRebalancePlanMutation = (): UseMutationResult<
  AxiosResponse<KentRebalancingPlan>,
  unknown,
  { clusterId: string; rebalancingPlanId: string },
  unknown
> => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ clusterId, rebalancingPlanId }) =>
      apiClient.kent.executeRebalancingPlan({
        organizationId: currentOrganization?.id ?? '',
        clusterId,
        id: rebalancingPlanId,
      }),
    onSuccess: async (_data, { clusterId }) => {
      await queryClient.invalidateQueries({
        queryKey: getKentRebalancePlanQueryKey(clusterId),
      });
    },
    onError: (error: unknown) => {
      const parsedError = parseApiError(error);

      notify.error(parsedError);
    },
  });
};
